import { ExcelTemplateType, LanguageType } from './enum.model';

export class ImportBuildingModel {
  name: string;
  extension: string;
  size: number;
  fileAsBase64: string;
  municipalityId: string;
  importType: ExcelTemplateType;
  language: LanguageType;
}
